<template>
  <div class="w2c_chat">
    <div v-if="!chat_id && !$store.state.chatEnded">
    <div class="w2c_chat_header" :style="{ background: $store.state.color }">
      <button class="w2c_hide_chat" @click="closeChat">x</button>
      <p class="w2c_white">Start a Chat</p>
<!--      <p class="w2c_white">Chatting with {{$store.state.discussion.recipient.name}}</p>-->
    </div>

      <div v-if="$store.state.errors.length > 0">{{ $store.state.errors }}</div>

      <p class="small" style="max-width: 350px; padding: 10px; margin: 0 auto;" v-if="!$store.state.user_is_live">{{ $store.state.recipient_name_before_chat }} is not available at the moment. Leave a message and we'll notify you of a response within 48 hours. Thank you!</p>

      <form @submit.prevent="submit" ref="form" class="w2c start_chat">

        <div class="">
          <input v-model="fname" type="text" name="chat[fname]" required placeholder="First Name" v-validate="'required'" data-vv-as="first name">
          <div style="color: red;">{{ errors.first('chat[fname]') }}</div>
        </div>
        <div class="">
          <input v-model="lname" type="text" name="chat[lname]" required placeholder="Last Name" v-validate="'required'" data-vv-as="last name">
          <div style="color: red;">{{ errors.first('chat[lname]') }}</div>
        </div>
        <div class="">
          <input v-model="email" type="text" name="chat[email]" required placeholder="Email Address" v-validate="'required'" data-vv-as="email">
          <div style="color: red;">{{ errors.first('chat[email]') }}</div>
        </div>
        <div style="display:flex;">
          <input type="checkbox" v-model="text" id="text" name="text" value="true"><label for="text"> Text me</label><br>
        </div>
        <div v-if="text">
          <masked-input
            type="text"
            name="chat[cellphone]"
            v-model="cellphone"
            placeholder="Mobile Number"
            :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
            :guide="true">
          </masked-input>
        </div>
        <div class="">
          <textarea v-model="body" name="message[body]" id="first_message" required placeholder="Your message" v-validate="'required'" data-vv-as="message"></textarea>
          <div style="color: red;">{{ errors.first('message[body]') }}</div>
        </div>

        <input type="hidden" id="recipient_type" name="chat[recipient_type]" value="User">
        <input type="hidden" id="recipient_id" name="chat[recipient_id]" :value="$store.state.recipient">
        <input type="hidden" id="url" name="chat[url]" :value="$store.state.url">
        <div class="">
          <button :style="styleObject" :disabled="disableBtn" ref="sendBtn" class="btn" @click.prevent="run_validations"><i v-if="disableBtn" class="fa fa-spinner fa-spin"></i> Send</button>
        </div>
      </form>
    </div>

    <div v-else>
      <div class="w2c_chat_header" :style="{ background: $store.state.color }">
        <button class="w2c_hide_chat" @click="closeChat">x</button>
        <p class="w2c_white">Chatting with {{ $store.getters.recipient_name }}</p>
      </div>
      <div refs="messages" id="messages" class="w2c_messages" v-chat-scroll="{smooth: true, notSmoothOnInit: true}">
      <template v-for="message in chat_messages">
        <div class="w2c_message sender_message" v-if="message.user_id === $store.state.discussion.sender_id">
          {{ message.body }}
        </div>
        <div v-else class="w2c_message recipient_message" :style="{ background: $store.state.color }">
          {{ message.body }}
        </div>
      </template>
      </div>

      <div v-if="$store.state.chatEnded" style="padding: 2px 10px;">
        This chat has been ended.
      </div>
      <form v-else @submit.prevent="submit" ref="form_message" class="w2c">
        <input v-validate="'max:5'" type="text" v-model="body" name="message[body]" id="new_message" required placeholder="Your message"
               data-vv-name="newMessage"
               data-vv-as="Message"></input>

        <input type="hidden" id="user_type" name="message[user_type]" value="User">
        <input type="hidden" id="user_id" name="message[user_id]" :value="$store.getters.sender">
        <button :style="styleObject" class="btn" @click.prevent="sendMessage">Send</button>
        <button :style="styleObject" class="btn" style="display: none;" @click.prevent="endChat">End Chat</button>
      </form>
<!--      <span v-if="errors" style="color: red; font-size: 12px; padding: 0 10px;">{{ errors.first('newMessage') }}</span>-->
    </div>

  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import MaskedInput from 'vue-text-mask'

function ColorLuminance(hex, lum) {

  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  var rgb = "#", c, i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i*2,2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
    rgb += ("00"+c).substr(c.length);
  }

  return rgb;
}

export default {
  data() {
    return {
      text: false,
      cellphone: '',
      disableBtn: false
    }
  },
  components: {
    MaskedInput
  },
  channels: {
    ChatChannel: {
      connected() {
        // console.log("Connected to the chat!");
      },
      rejected() {},
      received(data) {
        if (data.ended_at) {
          this.$store.state.chatEnded = true
        } else {
          this.$store.state.discussion.chat_messages.push(data)
        }
        // var container = this.$el.querySelector("#messages");
        // container.scrollTop = container.scrollHeight;
      },
      disconnected() {}
    }
  },

  methods: {
    run_validations() {
      this.$validator.validate().then(valid => {
        if (!valid) {
          console.log('Not valid')
        } else {
          this.disableBtn = true;
          this.createChat();
        }
      });
    },
    createChat() {
      let formData = new FormData(this.$refs.form)
      this.$store.dispatch('createChat', formData)
    },
    sendMessage() {
      let formData = new FormData(this.$refs.form_message)
      let payload = { 'formData': formData, 'chat_id': this.$store.state.chat_id}
      this.$store.dispatch('sendMessage', payload)
    },
    closeChat() {
      this.$store.state.chatActivated = false
    },
    endChat() {
      this.$store.dispatch('endChat', this.$store.state.chat_id)
    }
  },

  computed: {
    ...mapFields([
      'chat_id',
      'fname',
      'lname',
      'email',
      'body',
      'errors'
    ]),
    chat_messages() {
      return this.$store.state.discussion.chat_messages
    },
    styleObject: function() {
      return {
        '--color': this.$store.state.color,
        '--text-color': this.$store.state.text_color,
        '--color-hover': ColorLuminance(this.$store.state.color, -0.2)
      }
    }
  }
}
</script>

<style scoped lang="scss">
*:focus {
  outline: none;
}

.w2c_white {
  color: white;
  text-align: center;
}

.w2c_chat {
  all: unset;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  background: white;
  min-width: 330px;
  border-radius: 10px;
  margin-bottom: 25px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";


  p {
    //font-size: 2em;
    font-size: 14px;
    text-align: center;
    margin: 0;
  }

  .w2c_messages {
    //display: flex;
    //flex-direction: column;
    //justify-content: flex-end;

    max-height: 350px;
    min-height: 250px;
    overflow-y: auto;
    flex-shrink: 2;
    padding: 0 10px;

    .w2c_message {
      box-sizing: border-box;
      background: #e1e1e8;
      padding: 10px;
      font-size: 14px;
      border-radius: 1.125rem 1.125rem 1.125rem 0;
      margin: 7px 0;
      width: fit-content;
      //max-width: 66%;
      max-width: 420px;
      box-shadow:
        0 0 2rem rgba(black, 0.075),
        0rem 1rem 1rem -1rem rgba(black, 0.1);


      &.recipient_message {
        margin: 7px 0 7px auto ;
        border-radius: 1.125rem 1.125rem 0 1.125rem;
        color: white;
      }
    }
  }
}


.recipient_message {
  text-align: right;
}

.w2c_chat_header {
  height: 40px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
}

.w2c_hide_chat {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
  padding-left: 11px;
}

form.w2c {
  //padding: 10px;
  border-top: 1px solid #EEE;
  box-sizing: border-box;
  flex-basis: 4rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.5rem 0 1.5rem;

  &.start_chat {
    flex-direction: column;
  }


  input {
    border: 1px solid #ddd;
    background-image:none;
    background-color: white;
    padding: 0.5rem 1rem;
    margin-right: 1rem;
    margin-bottom: 10px;
    border-radius: 1.125rem;
    flex-grow: 2;
    box-shadow:
      0 0 1rem rgba(black, 0.1),
      0rem 1rem 1rem -1rem rgba(black, 0.2);

    font-family: Red hat Display, sans-serif;
    font-weight: 400;
    letter-spacing: 0.025em;
    min-width: 260px;
    width: 260px;

    &:placeholder {
      color: #999;
    }
  }

  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    box-shadow:none;
    min-width: 20px;
    width: 20px;
    margin: 12px -1px;

  }

  label {
    text-transform: none !important;
    font-weight: normal !important;
    min-width: 60px;
    margin: 8px 5px 0 !important;
  }

  input #new_message {
    border: 1px solid #ddd;
    background-image:none;
    background-color: white;
    padding: 0.5rem 1rem;
    margin-right: 1rem;
    border-radius: 1.125rem;
    flex-grow: 2;
    box-shadow:
      0 0 1rem rgba(black, 0.1),
      0rem 1rem 1rem -1rem rgba(black, 0.2);

    font-family: Red hat Display, sans-serif;
    font-weight: 400;
    letter-spacing: 0.025em;

    &:placeholder {
      color: #999;
    }
  }

  textarea {
    resize: none;
    min-height: 60px !important;
    border: 1px solid #ddd;
    background-image:none;
    background-color: white;
    padding: 0.5rem 1.3rem;
    //margin-right: 5rem;
    margin-bottom: 10px;
    border-radius: 1.125rem;
    flex-grow: 2;
    box-shadow:
      0 0 1rem rgba(black, 0.1),
      0rem 1rem 1rem -1rem rgba(black, 0.2);

    font-family: Red hat Display, sans-serif;
    font-weight: 400;
    letter-spacing: 0.025em;
    width: 260px;
    margin-left: -15px;

    &:placeholder {
      color: #999;
    }
  }

  .btn {
    border:none;
    background-image:none;
    background-color: var(--color);
    color: var(--text-color);
    padding: 0.5rem 1rem;
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 10px;
    border-radius: 1.125rem;
    flex-grow: 2;
    box-shadow:
      0 0 1rem rgba(black, 0.1),
      0rem 1rem 1rem -1rem rgba(black, 0.2);

    &:hover {
      background-color: var(--color-hover);
    }
  }
}
</style>
